import { combineReducers } from 'redux-immutable'
import companyCreateReducer from './company-create-reducer'
import companyListReducer from './company-list-reducer'
import companyEditReducer from './company-edit-reducer'
import companyGetReducer from './company-get-reducer'
import companyDeactivateReducer from './company-deactivate-reducer'
import companyExportReducer from './company-export-reducer'

export default combineReducers({
  companyCreate: companyCreateReducer,
  companyList: companyListReducer,
  companyEdit: companyEditReducer,
  companyGet: companyGetReducer,
  companyDeactivate: companyDeactivateReducer,
  companyExport: companyExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/company/index.js